import { buttonVariants } from '@e2n/ui';
import { EmptyCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/EmptyCard';
import { RotationsplanCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard';
import { Header } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Header';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { cn } from '@/lib/utils';
import { faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export function Uebersicht() {
  const { store } = useRotationsplanFeatureContext();
  const {
    data: {
      uebersicht: { rotationsplaene },
    },
  } = store;

  return (
    <div className="flex flex-col gap-6 items-start">
      <Header />
      <div
        key="uebersicht"
        className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rotationsplaene.length < 1 ? (
          <EmptyCard />
        ) : (
          rotationsplaene.map((plan) => (
            <Link key={plan.id} to={`/mitarbeiter/rotationsplan/${plan.id}`}>
              <RotationsplanCard rotationsplan={plan} />
            </Link>
          ))
        )}
      </div>
      <Link
        className={cn(
          buttonVariants({ variant: 'default', size: 'icon' }),
          'absolute md:hidden right-4 z-49 bottom-16 shadow-xl',
        )}
        to={`/mitarbeiter/rotationsplaene/uebersicht/create`}>
        <FontAwesomeIcon icon={faPlusLarge} size="lg" />
      </Link>
    </div>
  );
}
